export const statCards = () => {
    const rollingStats = document?.querySelectorAll('layflags-rolling-number');
    if (!rollingStats)
        return;

    const observerOptions = {
        root: null,
        rootMargin: '-16px',
        threshold: 0.2
    };

    rollingStats.forEach((stat) => {
        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    stat.setAttribute('value', (stat as HTMLElement).textContent!);
                }
            });
        };
    
        const observer = new IntersectionObserver(observerCallback, observerOptions);
    
        observer.observe(stat);
    })
}